/** Tool registry contract — the node "tools" agents are built from (`/api/tools`). */

import { api } from './api';

export interface ToolParam {
  name: string;
  type: string;
  required: boolean;
  description: string;
}

export interface ToolDef {
  id: string;
  name: string;
  category: string;
  description: string;
  config_params: ToolParam[];
  inputs: string[];
  outputs: string[];
  permission_enforced: boolean;
}

export async function fetchTools(): Promise<ToolDef[]> {
  const res = await api.get<{ tools: ToolDef[]; total: number }>('/tools');
  return res.tools;
}
